export const DEVELOPMENT_PLAN_FILTER_ARCHIVED = "archived";
export const DEVELOPMENT_PLAN_FILTER_NON_ARCHIVED = "nonArchived";

export const DEVELOPMENT_PLAN_FILTER_SPLIT = /\|\|/g;

export const ACTIVITY_TYPE_ONLINECOURSE = "onlinecourse";
export const ACTIVITY_TYPE_EXTERNAL_COURSE = "externalcourse";

export const COURSE_TYPE_ONLINE = "online";

export const TABLE_OBJECT_ID_PERSONALGOAL = 13;

export const GOAL_TYPE_STATUS = 1;
export const GOAL_TYPE_FIVESCALE = 2;
export const GOAL_TYPE_MEASURABLE = 3;
export const GOAL_TYPE_CHECKLIST = 4;

export const ORGGOALS_URL = "/v1/user/:personalId/organisationgoals";

export const ACTIVITY_CATEGORIES_API = "v1/activitycategories";
